// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"131fe2e5","331":"52eac85a","406":"92056d75","431":"ab58de5d","496":"92963507","629":"f763e6c8","805":"ae176a38","924":"cfb51a45","994":"0e49cc76"}[chunkId] + ".chunk.js";
};